module.exports = __webpack_public_path__ + "img/background-light-2.41636b07.webp";